<template>
  <form @submit.prevent="submit" class="form-wrapper with-loading" v-form:form novalidate >
    <div class="loading" v-if="isLoading">
      <Loader />
    </div>
    <div class="form-view">
      <h3 class="title">{{ $t('view.component.topup.auto.step2.authorizationHeader') }}</h3>
      <div class="autotopup-for-phone">
        <p>{{ $t('view.component.topup.auto.step2.labelPhone') }}</p>
        <p>{{ phone | phone }}</p>
      </div>
      <box-info>
        <p>
          <span v-html="$t('view.component.topup.auto.step2.authorizationInfo', {phone: $options.filters.phone(phone)})"></span>&nbsp;<a class="bold" @click.prevent="resendSmsCode" v-html="$t('view.component.topup.auto.step2.resendLink')"></a>
        </p>
      </box-info>
      <div class="form-row">
        <div class="input-wrapper">
          <input type="text"
                 autocorrect="off"
                 autocomplete="off"
                 spellcheck="false"
                 required
                 v-model="formData.smsCode"
                 id="smsCode"
                 name="smsCode" />
          <label for="smsCode">{{ $t('view.component.topup.auto.step2.authorizationCode') }}</label>
        </div>
        <p class="error-field"
           v-if="isErrorForField('smsCode')"
           v-html="getFieldErrorText('smsCode')">
        </p>
        <p class="error-field" v-if="showProcessError"
           v-html="$t('view.component.topup.auto.step2.errorSmsCode')">
        </p>
        <p class="hint-field" v-if="showResendSuccess"
           v-html="$t('view.component.topup.auto.step2.successResendSmsCode')">
        </p>
        <p class="error-field" v-if="showResendError"
           v-html="$t('view.component.topup.auto.step2.errorResendSmsCode')">
        </p>
      </div>
      <div class="form-row">
        <button type="submit" class="primary" :class="{disabled: !isFormValid()}">
          {{ $t('view.component.topup.auto.step2.buttonNext') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import FormMixin from '@/orange/mixins/form.mixin'
import { mapActions, mapMutations, mapState } from 'vuex'
import { ROUTING } from '@/orange/const/routing.const'
import Loader from '@/orange/components/Loader'
import BoxInfo from '../../common/BoxInfo'

export default {
  name: 'TopupAutoFormStep2',
  mixins: [FormMixin],
  components: { BoxInfo, Loader },
  data () {
    return {
      showProcessError: false,
      showResendError: false,
      showResendSuccess: false,
      formData: {
        smsCode: null
      }
    }
  },
  computed: {
    ...mapState({
      autotopup: state => state.autotopup.data,
      isLoading: state => state.autotopup.loading,
      phone: state => state.autotopup.data.contact.msisdn,
      smsCodeId: state => state.autotopup.data.smsCodeId
    })
  },
  methods: {
    ...mapMutations([
      'SET_AUTOTOPUP_STAGE',
      'RESET_AUTOTOPUP'
    ]),
    ...mapActions([
      'sendAutotopupAuthorizationCode',
      'confirmAutotopupAuthorizationCode'
    ]),
    resendSmsCode () {
      this.showResendSuccess = false
      this.showResendError = false
      this.showProcessError = false
      this.formData.smsCode = null
      this.form.resetForm()
      this.sendAutotopupAuthorizationCode()
        .then(() => {
          this.showResendSuccess = true
        })
        .catch(() => {
          this.showResendError = true
        })
    },
    goToStep1 () {
      this.$router.push(ROUTING.topup.auto.step1)
    },
    goToStep3 () {
      this.$router.push(ROUTING.topup.auto.step3)
    },
    submit () {
      this.showProcessError = false
      this.showResendSuccess = false
      this.showResendError = false
      if (this.form.invalid) {
        return
      }
      const data = {
        msisdn: this.phone,
        smsCodeId: this.smsCodeId,
        code: this.formData.smsCode
      }
      this.confirmAutotopupAuthorizationCode(data)
        .then(() => {
          this.SET_AUTOTOPUP_STAGE(3)
          this.goToStep3()
        })
        .catch(() => {
          this.showProcessError = true
        })
    }
  },
  created () {
    if (!this.phone) {
      this.RESET_AUTOTOPUP()
      this.goToStep1()
    }
  }
}
</script>

<style lang="scss" src="../../../assets/scss/components/_auto_topup-main.scss" scoped></style>
